import * as React from 'react'
import styled from 'styled-components'

import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { TypographyElement } from 'LuxKit/Typography/Typography'

const NoOverFlowBodyTextBlock = styled(BodyTextBlock)`
  ${TypographyElement} {
    overflow-wrap: anywhere;
  }
`

function ItemTitle({
  children,
}: React.PropsWithChildren) {
  return (
    <NoOverFlowBodyTextBlock
      variant="medium"
      weight="bold"
      lineClamp={2}
      wrap="pretty"
    >
      {children}
    </NoOverFlowBodyTextBlock>
  )
}

export default ItemTitle
